import { render, staticRenderFns } from "./DataInputCheckbox.vue?vue&type=template&id=552a0de4&scoped=true&"
import script from "./DataInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./DataInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DataInputCheckbox.vue?vue&type=style&index=0&id=552a0de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a0de4",
  null
  
)

export default component.exports